import React from 'react';
import { IIconProps } from 'ui/CircleIconButton';

export const ChatTrashIcon: React.FC<IIconProps> = React.memo(({...props}) => (
  <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.875 0.75L8.625 1.5H11.25V3H0.75V1.5H3.375L4.125 0.75H7.875ZM1.5 12.75C1.5 13.575 2.175 14.25 3 14.25H9C9.825 14.25 10.5 13.575 10.5 12.75V3.75H1.5V12.75ZM3 5.25H9V12.75H3V5.25Z" fill="#A08264" />
  </svg>

));

export default ChatTrashIcon;
